module.exports = __webpack_public_path__ + "img/check.8900b797.svg";